import { Sparkles, MessageSquareText, Video, ArrowRight } from "lucide-react";
import { buildBookingSmsHref } from "../lib/bookingSms";

// The "3 easy exchanges" that unlock the $1,500 → $550 price.
const EXCHANGES = [
  {
    icon: Sparkles,
    n: "01",
    title: "Show up with the car washed",
    desc: "Give it a rinse before you drop it off. Saves us 45 minutes of prep so we can keep the offer at $550 without cutting corners on the coating.",
  },
  {
    icon: MessageSquareText,
    n: "02",
    title: "Leave us an honest Google review",
    desc: "After you see the finished car, drop a real review on our GMB. Every review pushes us up the Mississauga search results and keeps this pricing sustainable.",
  },
  {
    icon: Video,
    n: "03",
    title: "Film 2 quick clips with us",
    desc: "One short video testimonial about your experience, plus a rolling shoot of your finished car for our reels. Together they take about 5-10 minutes on pickup day. that&rsquo;s the entire trade.",
  },
];

export default function UnlockOffer() {
  return (
    <section
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0c0119] via-[#1a0938] to-[#0c0119] border-y border-jester/30 overflow-hidden"
      data-testid="unlock-offer-section"
    >
      <div className="absolute -top-20 right-1/4 w-[500px] h-[500px] rounded-full bg-jester-purple/20 blur-[140px]" />
      <div className="absolute -bottom-20 left-1/4 w-[400px] h-[400px] rounded-full bg-acid/10 blur-[140px]" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        {/* Big price transformation */}
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           Why We Are Running This In October
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            The catch is fair.<br />
            <span className="text-jester">Do 3 easy things.</span><br />
            <span className="text-acid">Save $950.</span>
          </h2>

          {/* Price transformation bar */}
          <div className="mt-10 inline-flex items-center gap-4 md:gap-6 px-6 md:px-8 py-5 rounded-2xl border border-jester/40 bg-[#120127]/70 backdrop-blur-md">
            <div className="text-left">
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-label mb-1">
                Regular Price
              </div>
              <div className="font-stencil text-3xl md:text-4xl text-white/40 line-through">
                $1,500
              </div>
            </div>
            <ArrowRight className="w-6 h-6 text-acid flex-shrink-0" />
            <div className="text-left">
              <div className="text-[10px] uppercase tracking-[0.3em] text-acid font-label mb-1">
                October Rate
              </div>
              <div className="font-stencil text-4xl md:text-5xl text-acid">
                $550
              </div>
            </div>
          </div>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Every winter the shop books solid from November on. So we drop
            the price for a handful of October and early-November spots,
            build our winter content library, and lock your paint in before
            the first plow hits. Same 2-layer Gtechniq, same 5-year warranty.
            You just help us keep the marketing lean.
          </p>
        </div>

        {/* 3 exchange cards */}
        <div className="grid md:grid-cols-3 gap-5">
          {EXCHANGES.map((e, i) => {
            const Icon = e.icon;
            return (
              <article
                key={i}
                data-testid={`exchange-card-${i}`}
                className="relative p-7 rounded-2xl border border-jester/30 bg-[#120127]/70 backdrop-blur-sm hover:border-acid/50 transition-colors"
              >
                <div className="absolute top-5 right-5 font-stencil text-4xl text-jester-purple/40">
                  {e.n}
                </div>
                <div className="w-12 h-12 rounded-full bg-acid/15 border border-acid/40 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-acid" />
                </div>
                <h3 className="font-display text-xl text-white mb-3 leading-tight pr-8">
                  {e.title}
                </h3>
                <p
                  className="text-white/70 text-[15px] leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: e.desc }}
                />
              </article>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-14 flex flex-col items-center gap-3">
          <a
            href={buildBookingSmsHref()}
            data-testid="unlock-cta"
            className="group inline-flex items-center gap-3 px-10 h-14 rounded-full bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] text-sm uppercase transition-all shadow-[0_0_50px_rgba(168,224,0,0.5)]"
          >
            I&rsquo;m in. Book At $550
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <p className="text-xs text-white/50 font-label tracking-[0.15em] uppercase">
            Reply in an hour &middot; No obligation
          </p>
        </div>
      </div>
    </section>
  );
}
